import axios from "axios";
import getUserUserSurveyResp from "../queries/GetUserSurveyResponses";
import Compressor from "compressorjs";
import { getAPI } from "../api/getApi";
import { CreateProducts } from "../mutations/CreateProduct";
import moment from "moment";
import axiosGet from "../api/axiosGet";
import { CreateCNGUser } from "../mutations/CreateCNGUser";
import { client } from "..";
import { GetTransQuery } from "../queries/GetTransJob";
import { getSurveyDetails } from "../queries/GetSurveyDetails";
import { GetEcCardsQuery } from "../queries/GetECCardDetails";
import { getCardsQuery, getCNGCardsQuery } from "../queries/GetLPGCards";
import { getEcUserQuerry } from "../queries/GetEcUsers";
import { CreateEcUser } from "../mutations/CreateEcUsers";
import { InsertECUsers } from "../mutations/InsertECUSers";
// import moment from "moment";
const CRM_Token = "crm_token";
export function setInitalHeaders() {
  if (localStorage.token) {
    return {
      "Content-Type": "application/json",
      authorization: "Bearer " + localStorage.token,
    };
  }

  return {
    "Content-Type": "application/json",
    authorization:
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ikd1ZXN0IiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbImd1ZXN0Il0sIngtaGFzdXJhLWRlZmF1bHQtcm9sZSI6Imd1ZXN0In19.dFW-ZzED-qnnoWVb0r9oZIcmn2gSsBxqBp30BuUz1wk",
  };
}

let headers = new Headers();
export function getOTP([mobile], bool, loadingRef) {
  if (loadingRef) {
    loadingRef.current = true;
  }
  if (!mobile) {
    this.returnResult(false);
    return;
  }
  // SetphNum(num);
  // SetLoading(true);
  headers.append("Content-Type", "application/json");

  let data = bool
    ? {
      phone_number: mobile,
      qr_id: 1,
      skoda: true,
    }
    : {
      phone_number: mobile,
      qr_id: 1,
    };

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: "https://ve2gcu3nyeuftn6eakzhcre52u0nhxca.lambda-url.ap-south-1.on.aws/",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      //  console.log(response.data);
      localStorage.setItem("otp_id", response.data.insert_otp.id);
      localStorage.setItem("user_id", response.data.user.id);
      // loadingRef.current = false;
      this.returnResult(true);
      // SetLoading(false);
      // navigate("/verify-otp", {
      //   state: {
      //     otp_id: response.data.insert_otp.id,
      //     user_id: response.data.user.id,
      //     phone_number: sender.data.mobile,
      //   },
      // });
    })
    .catch(function (error) {
      // SetLoading(false);
      // this.returnResult(false);
    });
  if (loadingRef) {
    loadingRef.current = false;
  }
  if (!bool) {
    this.returnResult(true);
  }
}

export const onSkipClick = (setModelOpen, redirect) => {
  setModelOpen(false);
  redirect.current = true;
};

export const InsertCNGLeads = async (payload) => {
  const res = await getAPI("https://hm36k2dmmkhrkxryjjuqja5mfe0jrdqs.lambda-url.ap-south-1.on.aws/", payload);
  return res;
}

export function flattenArray(nestedArray) {
  const flattened = [];

  function flatten(arr) {
    arr.forEach((item) => {
      if (Array.isArray(item)) {
        flatten(item);
      } else {
        flattened.push(item);
      }
    });
  }

  flatten(nestedArray);

  return flattened;
}

export const getFreeFillForm = async (survey2, client, token, prefillValue, phNo) => {
  // console.log( prefillValue)

  const prefillData = JSON.parse(prefillValue);
  if (Array.isArray(prefillData)) {


    const { data } = await getUserUserSurveyResp(client, token, prefillData, phNo)
    survey2.setValue("name", data[0]?.response_details?.name)
    survey2.setValue("area", data[0]?.response_details?.area)
    survey2.setValue("profession", data[0]?.response_details?.profession)
    survey2.setValue("how do you know about Texvalley", data[0]?.response_details['how do you know about Texvalley'])
  }
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

export function onUploadName(survey2, survey_id) {
  console.log(survey_id)
  survey2.onUploadFiles.add(async (_, options) => {
    const random = Math.floor(Math.random() * 90 + 10)
    const base64 = await toBase64(options.files[0])
    const [, variable] = base64.split(',')
    const file_name = random + '_gogas_img-' + moment().format('DD/MM/YYYY hh:mm:ss a').replace(/[^a-zA-Z0-9.]/g, "_")
      .replace(/\s+/g, "_") + ".png";
    console.log(file_name, 'date', variable);
    const filename = options.files[0].name
      .replace(/[^a-zA-Z0-9.]/g, "_")
      .replace(/\s+/g, "_");
    // console.log(options.files[0], 'file');
    if (survey_id === 1052 || survey_id === 1815 || survey_id === 1696) {
      const vari = {
        "filename": file_name,
        "file": variable
      }
      const res = await getAPI("https://2ofd7a6iv2hv6a3jlyz5mwxazu0udszw.lambda-url.ap-south-1.on.aws/", vari)
      console.log(res?.data?.result?.Location, 'res');
      if (res.data.success) {
        options.callback(
          "success",
          options.files.map((file) => {
            return {
              file: file,
              content: res?.data?.result?.Location,
            };
          })
        );
      }

    } else {
      const uploadToS3 = async (fileToUpload) => {
        const b64 = await toBase64(fileToUpload);
        const [, data] = b64.split(',');
        const payload = {
          "bucket": "extraa-public",
          "root_prefix": "resumes/",
          "contentType": fileToUpload.type,
          "filename": `${random}_${filename}`,
          "file": data
        };
        const res = await getAPI("https://t6m4xpt3sky7t5ichlxd4jk5zi0wfmcx.lambda-url.ap-south-1.on.aws/", payload);
        console.log(res?.data, 'res');
        if (res.data.success) {
          options.callback(
            "success",
            options.files.map((file) => {
              return {
                file: file,
                content: res?.data?.result?.url,
              };
            })
          );
        }
      };

      if (options.files[0]?.type.startsWith("image/") && options.files[0]?.size > 2100000) {
        new Compressor(options.files[0], {
          quality: 1,
          maxHeight: 1000,
          maxWidth: 1000,
          success(result) {
            uploadToS3(result);
          },
          error(err) {
            console.log(err.message);
          },
        });
      } else {
        uploadToS3(options.files[0]);
      }
    }
  });
}

export const CrmActivityCreate = async (items) => {
  const url = 'https://tq3yzya34nz7vh6673gt4fsuta0mdwjf.lambda-url.ap-south-1.on.aws/'
  let variables = {}
  const members = items?.members?.length > 0 && items?.members.map((x) => {
    return { "directus_users_id": { "id": x } }
  }) || null
  const member = items?.member?.length > 0 && items?.member.map((x) => {
    return { "directus_users_id": { "id": x } }
  }) || null
  if (items?.form_type === 'task') {
    variables = {
      "merchant_id": items?.merchant || "",
      "token": localStorage.getItem(CRM_Token),
      "task_name": items?.task_name || '',
      "description": items?.description || '',
      "due_on": items?.due_on || '',
      "status": items?.status || '',
      "member_id": members || null,
      "type": items?.form_type
    }
  } else if (items?.form_type === 'merchants') {
    variables = {
      merchant_name: items?.merchant_name,
      area: items?.area,
      city: items?.city,
      status: items?.status,
      scale: items?.scale,
      industry: {
        id: items?.industry
      },
      contacts: {
        name: items?.name,
        mobile: items?.mobile,
        designation: items?.designation,
        email: items?.email || ''
      },
      "type": items?.form_type
    }
  }
  else {
    variables = {
      "add_type": items['add Type'],
      "contact_id": items?.contact_name,
      "member_id": members || null,
      "outcome": items['out Come'],
      "notes": items?.notes,
      "start_time": items['start Time'],
      "end_time": items['end Time'],
      "merchant_id": items?.merchant,
      "token": localStorage.getItem(CRM_Token),
      "task_name": items?.task_name || '',
      "description": items?.description || '',
      "due_on": items?.due_on || '',
      "status": items?.status || '',
      "member": member,
      "type": items?.form_type,
      "img_url": items?.img_url?.[0]?.content || items?.file?.[0]?.content || ""
    }
  }
  console.log(variables, "variables", items);
  const res = await getAPI(url, variables);
}

export const create_product = async (data) => {
  const images = [data?.files[0]?.content]
  if (data?.files2?.length > 0) {
    images.push(data?.files2[0].content)
  }
  if (data?.files3?.length > 0) {
    images.push(data?.files3[0].content)
  }
  if (data?.files4?.length > 0) {
    images.push(data?.files4[0].content)
  }
  const category = [data?.category]
  if (data?.category1?.length > 0) {
    category.push(data?.category1)
  }
  if (data?.category2?.length > 0) {
    category.push(data?.category2)
  }
  if (data?.category3?.length > 0) {
    category.push(data?.category3)
  }

  const result = {
    "name": data?.name,
    "brand": data?.brand,
    "category": category,
    "images": images,
    "description": data?.desc,
    "type": data?.product_type,
    "product_variants": {
      "data": {
        "stock": data?.stock,
        "sale_price": data?.sale_price || 0
      }
    },
    "metadata": {
      "model_no": data?.model_no || '',
      "hsn_code": data?.hsn_code || '',
      "short_desc": data?.short_desc || '',
      "extraa_gst_persentage": data?.extraa_gst,
      "gst_persentage": data?.gst,
      "CountryOfOrigin": "India",

    },
    "active": data?.status === "Active"
  }
  const res = await CreateProducts(result)
  // console.log(result, 'Product Results', res);
}

export const send_coins = async (data) => {
  const futureDate = moment().add(14, 'days');
  // const redeemDate=moment(data?.redeemDate).add(14,'days')
  const formattedFutureDate = futureDate.format('YYYY-MM-DD');
  // const formattedRedeemDate = redeemDate.format('YYYY-MM-DD');
  let variables = {}
  if (data?.wallet_id) {
    variables = {
      "wallet_objects": [
        {
          "balance": 0,
          "user_id": data?.user_id,
          "coin_type": 7,
          "store_id": 1
        }
      ],
      "transaction_objects": [
        {
          "sender_wallet_number": `${data?.user_id || 0}-7`,
          "receiver_wallet_number": "2-7",
          "coin_type": 7,
          "store_id": 1,
          "amount": Math.floor(data?.amount)
        }
      ],
      "where": {
        "_or": [
          {
            "wallet_number": {
              "_eq": `2-7`
            }
          }
        ]
      },
      "sender_id": data?.wallet_id,
      "amount": Math.floor(data?.amount),
      "debit_amount": Math.floor(data?.amount),
      "sender_metadata": { "redeemDate": formattedFutureDate }
    }
  } else {
    variables = {
      "wallet_objects": [
        {
          "balance": 0,
          "user_id": data?.user_id,
          "coin_type": 7,
          "store_id": 1
        }
      ],
      "transaction_objects": [
        {
          "sender_wallet_number": "1-7",
          "receiver_wallet_number": `${data?.user_id || 0}-7`,
          "coin_type": 7,
          "store_id": 1,
          "amount": Math.floor(data?.coins)
        }
      ],
      "where": {
        "_or": [
          {
            "wallet_number": {
              "_eq": `${data?.user_id || 0}-7`
            }
          }
        ]
      },
      "sender_id": "74",
      "amount": Math.floor(data?.coins),
      "debit_amount": Math.floor(data?.coins),
      "metadata": { "firstPurchase": moment().format('YYYY-MM-DD'), "redeemDate": formattedFutureDate }
    }
  }
  if (data?.firstPurchase && data?.firstPurchase !== '') {
    delete variables.metadata
  }
  const url = 'https://qbuoeunhnft5h3n7x4lgupjchi0vfltp.lambda-url.ap-south-1.on.aws/'
  const res = await getAPI(url, variables);
  if (data?.wallet_id) {
    await axiosGet(`https://api.growaasan.com/api/sendPosCommunication?clietnId=100365&authKey=Q0ptUDJ1dTlzZFYrd0RMUFR6aU5OUT09&communicationType=2&waTemplateName=gogas_redeem&waTemplateLang=en&country_code=91&customerMobile=${data?.mobile}&varCount=3&var1=${data?.name}&var2=${data?.amount}&var3=${data?.balance - data?.amount}`)
  } else {
    await axiosGet(`https://api.growaasan.com/api/sendPosCommunication?clietnId=100365&authKey=Q0ptUDJ1dTlzZFYrd0RMUFR6aU5OUT09&communicationType=2&waTemplateName=gogas_refueling&waTemplateLang=en&country_code=91&customerMobile=${data?.mobile}&varCount=5&var1=${data?.name}&var2=${data?.amount}&var3=${data?.coins}&var4=${res?.data?.receiver_wallets?.returning?.length > 0 && res?.data?.receiver_wallets?.returning[0]?.balance}&var5=${moment(formattedFutureDate).format("DD/MM/YYYY")}`)

  }
  // console.log(res, 'result');
}

export const gogasLocation = async (data) => {
  // console.log(data);
  const url = "https://qfw6oges6ys3btp4ypdxrhp7wu0ziasr.lambda-url.ap-south-1.on.aws/"
  const res = await getAPI(url, data);

}

export const gogasCoinAdding = async (values) => {
  const url = "https://gogas-api.extraa.in/add-coins"
  const variables = values
  const res = await getAPI(url, variables);
  // console.log(res, 'values');
  return res
}

export const gogasCoinsRedeem = async (values) => {
  const url = "https://gogas-api.extraa.in/wallet-transaction"
  const variables = values
  const res = await getAPI(url, variables);
  // console.log(values, 'values');
  return res
}

export const gogasCNGUsers = async (values, token) => {
  const res = await CreateCNGUser(values, token)
  return res
}

export const ApiFunction = async (url, variables) => {
  const res = await getAPI(url, variables);
  return res
}

export const gogasCNGWalletTrans = async (values, token) => {
  console.log(values, 'values');
  const res = await getAPI(`https://gogas-cng.extraa.in/user/${values?.user_id}/points/burn`,
    {
      "coinType": 1,
      "points": values?.amount,
      "storeId": 1,
      "previous_kms": values?.previous_odometer,
      "driver_name": values?.driver_name,
      "current_kms": values?.current_odometer,
      "cng_rate": values?.cng_rate || 0,
      "cng_qty": Math.round(values?.cng_qty * 100) / 100 || 0,
      "mileage": values?.mileage > 0 && Math.round(values?.mileage * 100) / 100 || 0,
      "img_url": values?.img_url,
      "acc_id": Number(values?.acc_id),
      "vehicle_number": values?.vehicle_number,
      "odometer_img": values?.img_url_2
    },
    {
      "token": token
    }
  )
  // console.log(res, 'result');
  const { data } = await client.query({
    query: GetTransQuery,
    variables: { "id": res?.data?.job?.id },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }

  }
  )
  // console.log(data, 'data')
  return data?.cng_gogas_transaction_jobs_by_pk
}

export const GetSurveyDetails = async (phone, surveyId) => {
  const { data } = await client.query({
    query: getSurveyDetails,
    variables: {
      "id": surveyId,
      "_or": [{ "response_details": { "_cast": { "String": { "_ilike": `%\"mobile\": \"${phone}\"%` } } } },
      { "response_details": { "_cast": { "String": { "_ilike": `%\"mobile\": ${phone}%` } } } }
      ]
    },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }
  }
  )
  // console.log(data, 'data');
  return data.survey_responses;
}

export const GetECCardsDetails = async (phone, qr_code) => {
  const { data } = await client.query({
    query: GetEcCardsQuery,
    variables: {
      "qr_code": qr_code,
      "phone_number": phone
    },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }
  }
  )
  // console.log(data, 'data');
  return data;
}

export const GetLPGardsDetails = async (phone, qr_code) => {
  const { data } = await client.query({
    query: getCardsQuery,
    variables: {
      "qr_code": qr_code,
      "phone_number": phone
    },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }
  }
  )
  // console.log(data, 'data');
  return data;
}
export const GetEcUserDetails = async (phone, name, qr, countryCode) => {
  const { data } = await client.query({
    query: getEcUserQuerry,
    variables: {
      "phone_number": phone,
      "qr_code": qr
    },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }
  }
  )
  let userData
  let obj = {
    mobile: phone,
    name: name,
    country_code: countryCode
  };

  if (data?.ec_users[0]?.id) {
    userData = {
      userId: data?.ec_users[0]?.id,
      qr_id: data?.ec_cards[0]?.id
    };
  }
  else {
    const tempResp = await InsertECUsers(obj, client)
    userData = {
      userId: tempResp?.data?.insert_ec_users_one?.id,
      qr_id: data?.ec_cards[0]?.id
    };
  }

  // console.log(data, 'data');
  return userData;
}

export const GetCNGCardsDetails = async (qr_code) => {
  const { data } = await client.query({
    query: getCNGCardsQuery,
    variables: {
      "_eq": qr_code
    },
    context: {
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
      }
    }
  }
  )
  return data?.cng_gogas_cards;
}

export function decodeUserData(encodedParam) {
  if (!encodedParam) return { name: "", mobile: "" };
  try {
    // Convert URL-safe base64 back to standard base64
    let base64 = encodedParam.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
      base64 += "=";
    }

    // Decode base64 to string
    const decoded = atob(base64); // e.g. "Rahul Sharma_9876543210"

    // Split by the last underscore (in case the name itself contains an underscore)
    const lastUnderscoreIndex = decoded.lastIndexOf("_");
    if (lastUnderscoreIndex === -1) {
      return { name: decoded, mobile: "" };
    }
    const name = decoded.substring(0, lastUnderscoreIndex);
    const mobile = decoded.substring(lastUnderscoreIndex + 1);

    return { name, mobile };
  } catch (err) {
    console.error("decodeUserData error:", err);
    return { name: "", mobile: "" };
  }
}